import { render, staticRenderFns } from "./ed-add-menu.vue?vue&type=template&id=796f127b&scoped=true&"
import script from "./ed-add-menu.ts?vue&type=script&lang=ts&"
export * from "./ed-add-menu.ts?vue&type=script&lang=ts&"
import style0 from "./ed-add-menu.scss?vue&type=style&index=0&id=796f127b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f127b",
  null
  
)

export default component.exports